import { put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import HttpResponse from "types/httpResponse";
import {
  base64DecodeFailure,
  base64DecodeSuccess,
  base64EncodeFailure,
  base64EncodeSuccess,
  guidGenerateFailure,
  guidGenerateSuccess,
  md5HashFailure,
  md5HashSuccess,
  urlDecodeFailure,
  urlDecodeSuccess,
  urlEncodeFailure,
  urlEncodeSuccess,
} from "reducers/encodeSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import EncodeRequest from "types/encodeRequest";
import encodeSlice from "reducers/encodeSlice";
import EncodeResponse from "types/encodeResponse";

function* md5HashSaga(action: PayloadAction<EncodeRequest>) {
  try {
    const response: HttpResponse<EncodeResponse> = yield axios.post(
      `/encode/md5hash`,
      action.payload
    );
    yield put(md5HashSuccess(response.data));
  } catch (error: any) {
    yield put(md5HashFailure(error.message));
  }
}

function* base64EncodeSaga(action: PayloadAction<EncodeRequest>) {
  try {
    const response: HttpResponse<EncodeResponse> = yield axios.post(
      `/encode/base64encode`,
      action.payload
    );
    yield put(base64EncodeSuccess(response.data));
  } catch (error: any) {
    yield put(base64EncodeFailure(error.message));
  }
}

function* base64DecodeSaga(action: PayloadAction<EncodeRequest>) {
  try {
    const response: HttpResponse<EncodeResponse> = yield axios.post(
      `/encode/base64decode`,
      action.payload
    );
    yield put(base64DecodeSuccess(response.data));
  } catch (error: any) {
    yield put(base64DecodeFailure(error.message));
  }
}

function* urlEncodeSaga(action: PayloadAction<EncodeRequest>) {
  try {
    const response: HttpResponse<EncodeResponse> = yield axios.post(
      `/encode/urlencode`,
      action.payload
    );
    yield put(urlEncodeSuccess(response.data));
  } catch (error: any) {
    yield put(urlEncodeFailure(error.message));
  }
}

function* urlDecodeSaga(action: PayloadAction<EncodeRequest>) {
  try {
    const response: HttpResponse<EncodeResponse> = yield axios.post(
      `/encode/urldecode`,
      action.payload
    );
    yield put(urlDecodeSuccess(response.data));
  } catch (error: any) {
    yield put(urlDecodeFailure(error.message));
  }
}

function* guidGenerateSaga(action: PayloadAction<EncodeRequest>) {
  try {
    const response: HttpResponse<EncodeResponse> = yield axios.post(
      `/encode/guidgenerate`,
      action.payload
    );
    yield put(guidGenerateSuccess(response.data));
  } catch (error: any) {
    yield put(guidGenerateFailure(error.message));
  }
}

function* encodeSaga() {
  yield takeLatest(encodeSlice.actions.guidGenerate, guidGenerateSaga);
  yield takeLatest(encodeSlice.actions.urlEncode, urlEncodeSaga);
  yield takeLatest(encodeSlice.actions.urlDecode, urlDecodeSaga);
  yield takeLatest(encodeSlice.actions.base64Encode, base64EncodeSaga);
  yield takeLatest(encodeSlice.actions.base64Decode, base64DecodeSaga);
  yield takeLatest(encodeSlice.actions.md5Hash, md5HashSaga);
}

export default encodeSaga;
